import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const maxCacheNumber = 6;
const maxCacheMinutes = 60;

class CacheStore {
    cacheStore = null;

    getStore() {
        if (!this.cacheStore) {
            if (window.sspStores && window.sspStores.cache) {
                this.cacheStore = window.sspStores.cache;
            } else {
                this.createStore();
            }
        }
        return this.cacheStore;
    }

    // eslint-disable-next-line class-methods-use-this
    calcOptionStamp(req) {
        return JSON.stringify(req);
    }

    createStore() {
        this.cacheStore = new Vuex.Store({
            namespaced: true,
            state: {
                queue: {},
                cache: {}
            },
            mutations: {
                clearCache: (state, payload = { api: 'general' }) => {
                    const { api } = payload;
                    if (state.queue[api]) {
                        state.queue[api] = [];
                    }
                    if (state.cache[api]) {
                        state.cache[api] = {};
                    }
                },
                setCache: (state, payload = { api: 'general', req: '', data: {} }) => {
                    const { api } = payload;
                    const { req } = payload;
                    const { data } = payload;
                    if (!state.queue[api]) {
                        state.queue[api] = [];
                    }
                    if (!state.cache[api]) {
                        state.cache[api] = {};
                    }

                    const optionsStamp = this.calcOptionStamp(req);

                    // update cache
                    if (!state.cache[api][optionsStamp]) {
                        if (state.queue[api].length >= maxCacheNumber) {
                            const keyToRemove = state.queue[api].shift();
                            delete state.cache[api][keyToRemove];
                        }

                        state.queue[api].push(optionsStamp);
                    }

                    // parse and cache the results returned from the api
                    state.cache[api][optionsStamp] = {
                        raw: data,
                        // caching time, in order to make sure the cache is saved for max 5 mins
                        timeStamp: new Date(),
                        optionsStamp
                    };
                }
            },
            getters: {
                getFromCache: (state) => (api, req = '') => {
                    const optionsStamp = this.calcOptionStamp(req);
                    const apiCache = state.cache[api];
                    const isExpired = (
                        !apiCache
                        || !apiCache[optionsStamp]
                        || !apiCache[optionsStamp].timeStamp
                        || (apiCache[optionsStamp].timeStamp.getTime()
                            + (maxCacheMinutes) * 60 * 1000) < new Date().getTime()
                    );
                    if (!isExpired) {
                        return state.cache[api][optionsStamp].raw;
                    }

                    return null;
                }
            }
        });

        if (!window.sspStores) {
            window.sspStores = {};
        }

        window.sspStores.cache = this.cacheStore;
    }
}

export default new CacheStore();
